import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography} from '@mui/material';
import {ExamModule} from '@cp/model';
import ModuleViewGenerate from './ModuleViewGenerate';

export interface ModuleViewTopicsTableProps {
  examModule: ExamModule;
}

export default function ModuleViewTopicsTable({examModule}: ModuleViewTopicsTableProps) {
  return (
    <TableContainer component={Paper} sx={{border: '1px solid #e0e0e0'}}>
      <Table>
        <TableHead>
          <TableRow sx={{bgcolor: '#f5f5f5'}}>
            <TableCell sx={{fontWeight: 600}}>Category</TableCell>
            <TableCell sx={{fontWeight: 600}}>Topic ({examModule.topics.length})</TableCell>
            <TableCell sx={{fontWeight: 600}}>Detail</TableCell>
            <TableCell sx={{fontWeight: 600}}>Generate Questions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {examModule.topics.map((topic) => (
            <TableRow key={topic.topic} sx={{'&:nth-of-type(odd)': {bgcolor: '#fafafa'}}}>
              <TableCell sx={{fontWeight: 500}}>{topic.category}</TableCell>
              <TableCell>{topic.topic}</TableCell>
              <TableCell sx={{maxWidth: 300}}>
                <Typography
                  variant="body2"
                  sx={{
                    color: '#666',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                  title={topic.detail || ''}
                >
                  {topic.detail || '-'}
                </Typography>
              </TableCell>
              <TableCell>
                <ModuleViewGenerate examModule={examModule} topic={topic} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
